angular.module('iconoglobe')
.factory("ParentCat", ["$http", "$q", function($http, $q){
  
  var defer = $q.defer();
  var categories;
  var get = function(){
    $http.get('/api/getcategories').then(function(res) {
        categories = res.data;
        defer.resolve(categories);
    }, function(err){
      console.log(err);
    });
    return defer.promise;
  }
  return {
    get: get
  }
}])